module.exports = __webpack_public_path__ + "img/Tree-Overlay.png";